import React from "react";

const Arrow = () => {
  return (
    <div>
      <svg
        width="15"
        height="13"
        viewBox="0 0 15 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9419 7.17656C11.8939 7.17656 11.8422 7.17656 11.7942 7.17656C8.41853 7.17656 5.03919 7.17656 1.66353 7.17656C1.29051 7.17656 1.05414 6.96166 1.00613 6.57913C0.958117 6.2138 1.19818 5.85276 1.5158 5.81408C1.57859 5.80548 1.64507 5.80978 1.70785 5.80978C5.07242 5.80978 8.4333 5.80978 11.7979 5.80978C11.8459 5.80978 11.8939 5.80978 11.9493 5.80978C11.9345 5.72812 11.8865 5.70233 11.8533 5.65935C10.8672 4.50747 9.87737 3.35988 8.88758 2.208C8.5478 1.81258 8.6549 1.20655 9.0944 1.03893C9.33077 0.948668 9.53759 1.01744 9.71487 1.22374C10.0029 1.55899 10.2873 1.88994 10.5754 2.22519C11.6391 3.46304 12.7027 4.70088 13.7664 5.93872C14.0803 6.30406 14.0766 6.68229 13.7627 7.04762C12.4183 8.61212 11.074 10.1766 9.72964 11.7411C9.55975 11.9388 9.3677 12.0506 9.12025 11.9775C8.67706 11.8443 8.51825 11.2296 8.83218 10.8428C9.04639 10.5763 9.27537 10.3227 9.49697 10.0649C10.2836 9.14938 11.0703 8.23389 11.857 7.3227C11.8902 7.28402 11.9308 7.25823 11.9678 7.22814C11.9604 7.21095 11.9493 7.19376 11.9419 7.17656Z"
          fill="white"
          stroke="white"
        />
      </svg>
    </div>
  );
};

export default Arrow;
